export default __webpack_public_path__ + "static/media/ic_warning.9bacc4fb.svg";